var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetModelGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4304 88.2364L74.521 96.8498L111.509 118.07L148.498 96.8151L133.326 88.064",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0101 90.8594L83.748 96.7764L111.165 112.237L139.899 96.4089L129.174 90.5024",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.675 107.475L110.505 103.399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.292 91.6672L116.773 99.7749",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4304 68.022L74.521 76.6354L111.509 97.8561L148.498 76.6007L133.326 67.8496",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0101 70.6446L83.748 76.5616L111.165 92.0224L139.899 76.194L129.174 70.2876",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.675 87.26L110.505 83.1841",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.292 71.4526L116.773 79.5603",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M148.31 56.3337L111.322 35L74.3315 56.3684L111.32 77.589L148.31 56.3337Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6631 56.3626L111.321 37.9624L143.127 56.2963L111.321 74.8321L79.6631 56.3626Z",
    fill: "#CDD9E2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.8 43.8574L111.322 40.2888L83.5605 56.2949L110.977 71.7557L139.712 55.9274L122.546 46.4718",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.487 66.9931L110.317 62.9172",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.105 51.1858L116.586 59.2935",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5771 47.1587L104.06 49.6364",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.84 52.2639L119.232 57.816",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06641 57.2463L34.3272 75.7548L66.588 57.2163",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3276 89.267L66.5884 70.7285",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3276 102.78L66.5884 84.2412",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06689 57.2458L2.06952 97.7842",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5884 57.2153L66.591 97.7535",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3276 75.7544L34.3303 116.293",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06934 97.7834L34.3302 116.292L66.5909 97.7534",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66113 62.3442L10.84 65.3934V72.8518L5.66113 69.8484V62.3442Z",
    fill: "#CDD9E2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1421 67.7378L20.3209 70.7386V78.2453L15.1421 75.3013V67.7378Z",
    fill: "#CDD9E2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6226 73.1316L29.8015 76.0698V83.5424L24.6226 80.7346V73.1316Z",
    fill: "#CDD9E2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66113 75.3716L10.84 78.4208V85.8791L5.66113 82.8757V75.3716Z",
    fill: "#CDD9E2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1421 80.7656L20.3209 83.7664V91.2731L15.1421 88.3291V80.7656Z",
    fill: "#CDD9E2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6226 86.1589L29.8015 89.0972V96.5697L24.6226 93.7618V86.1589Z",
    fill: "#CDD9E2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66113 89.0894L10.84 92.1385V99.5969L5.66113 96.5934V89.0894Z",
    fill: "#CDD9E2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1421 94.4841L20.3209 97.4849V104.992L15.1421 102.048V94.4841Z",
    fill: "#CDD9E2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6226 99.8782L29.8015 102.816V110.289L24.6226 107.481V99.8782Z",
    fill: "#CDD9E2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9672 56.0215L33.7064 37.4148L2.68896 55.6488",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetModelGrey);
export default __webpack_public_path__ + "static/media/sheet_model_grey.f1009b36230a3f6098ea191228ec585e.svg";
export { ForwardRef as ReactComponent };